const RoutesToPages = {
    homePage: '/',
    articles: 'articles',
    categories: 'categories'
};

export default RoutesToPages;